import intl from "react-intl-universal"
import { useGlobalContext } from 'hooks/useGlobalContext';
import { useZsagContext } from "../context/zsagContext"
import IconGenerateSAG from 'images/generate-szag-icon.svg'
import { generateZSAG } from "../auto-load-optimization.service"
import { errorMessage } from "../utils/validate"
import ButtonIcon from "components/button-icon";

const GenerateZsag = () => {
  const { showFeedback } = useGlobalContext()
  const {
    setLoading,
    volumes,
    setVolumes,
    linesForDelete,
    filters,
    setHaveUnsavedChanges
  } = useZsagContext()

  const handleGenerateZSAG = () => {
    setLoading(true)
    const schedules = [...volumes.Schedules.filter(schedule => schedule.Process), ...linesForDelete]

    generateZSAG(filters, schedules)
      .then(response => {
        setVolumes({ ...response });
        showFeedback(intl.get('autoLoadOptimization.feedbacks.successfullyGeneratedSag'));
        setHaveUnsavedChanges(false);
      })
      .catch((e) => processError(e))
      .finally(() => setLoading(false))
  }

  const processError = e => {
    showFeedback(errorMessage(e));
  }

  return (
    <div className='btn-wrapper' data-testid='wrapper-generate-sag'>
      <ButtonIcon
        buttonIcon={<img src={IconGenerateSAG} alt="icon-generate-sag" width={'24px'} height={'24px'} />}
        buttonType="primary"
        buttonText={intl.get('autoLoadOptimization.generateZSAG')}
        className='btn-generate'
        onClick={handleGenerateZSAG}
      />
    </div>
  )
}

export default GenerateZsag
